import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { getAdminUsersAsync, getAdminUsersCountAsync, selectUserCount, selectUserFilterOptions, selectUsers } from '../../../app/store/reducers/auth/authReducer';
import { Table, Col, Card, Flex, Space } from 'antd';
import { RoleStatus } from '../../../helper/Status';
import { Link } from 'react-router-dom';



const AdminList = () => {
    const users = useSelector(selectUsers)
    const count = useSelector(selectUserCount)
    const filters = useSelector(selectUserFilterOptions)
    const dispatch = useDispatch()



    const columns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          sorter: true,
          render: (_, record) => {
            return (
              <Link to={`../account/${record?.id}`}>{record?.name}</Link>
            )
          },
        },
        {
          title: 'Email',
          key: 'email',
          render: (_, record) => (
            <Space size="middle">
              <a>{record.email}</a>
            </Space>
          ),
        },
        {
            title: 'Role',
            key: 'type',
            render: (_, record) => {
                return (
                <Space key={record.type} size="middle">
                  <a>{RoleStatus(record.type)}</a>
                </Space>
                )
            },
          },
      ];


    const loadRandomProducts = () => {
      dispatch(getAdminUsersAsync({...filters}))
      dispatch(getAdminUsersCountAsync({...filters}))
    } 
  
    useEffect(() => {
      loadRandomProducts()
    },[filters])
  
    const handleTableChange = (pagination, filters, sorter) => {
        console.log("table", pagination, filters, sorter)
      };
  
    return (
      <>
          <Card>
          <Flex align="center" justify="space-between" style={{borderBottom: "2px solid green"}}>
            <Col>
            <h4>Accounts</h4>
            </Col>
          </Flex>
        <Table
          columns={columns} 
          dataSource={users} 
          pagination={{
            current: filters.page,
            pageSize: filters.limit,
            total: count,
          }} 
          scroll={{
            // y: 240,
          }}
          onChange={handleTableChange}
          />
        </Card>
      </>
    )
}

export default AdminList